var scope_0 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7d6ada04347fe4121ed2ab658de042ea.js').default;
var scope_1 = require('/github/workspace/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    